module.exports = __webpack_public_path__ + "media/application/images/home/intro_images/feature_desert_mob-11ad19cf21d4b7c992065aeabb1fcc55.jpg";